import { FormControlLabel } from '@mui/material';
import styled from 'styled-components';

import { TRadioGroupOptionProps } from '@/shared/components/ui/form/components/radio-group/radio-group.types';

export const RadioGroupOption = styled(
  FormControlLabel,
)<TRadioGroupOptionProps>`
  && {
    margin: 0;
    padding: 0.25rem 0.5rem;
    border-radius: ${({ theme }) => theme.shape.inputRadius.medium};
    max-width: ${({ $wide }) => ($wide ? 'none' : '170px')};
    width: ${({ $wide }) => ($wide ? '100%' : '170px')};
    align-items: ${({ $wide }) => ($wide ? 'flex-start' : 'center')};
    gap: 0.25rem;
    transition: all 0.1s ease-in-out;

    & > .MuiButtonBase-root {
      margin-left: -0.125rem;
    }

    box-shadow: inset 0 0 0 1px
      ${({ theme, $error }) =>
        $error
          ? theme.palette.status.red.stroke
          : theme.palette.stroke.primary};

    background: ${({ theme, $error }) =>
      $error ? theme.palette.danger.light : theme.palette.background.input};

    &:not(.Mui-disabled):hover {
      box-shadow: inset 0 0 0 1px
        ${({ theme }) => theme.palette.stroke.secondary};

      .MuiRadio-root:not(.Mui-checked) > svg {
        color: ${({ theme }) => theme.palette.stroke.secondary};
      }
    }

    &.Mui-disabled {
      background: ${({ theme }) => theme.palette.background.default};

      .MuiRadio-root > svg {
        color: ${({ theme }) => theme.palette.text.disabled};
      }

      .MuiTypography-root {
        color: ${({ theme }) => theme.palette.text.primary};
      }
    }
  }
`;
